import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { List, ListDivider } from 'react-toolbox/lib/list'
import { renderNothing, branch, lifecycle, compose, nest, withState, withHandlers } from 'recompose'
import CSSModules from 'helpers/CSSModulesUtil'
import T from 'i18n-react'

import Divider from 'components/fulcrum/divider/Divider'
import Card from './Card'
import CardHeader from 'components/custom/Card/CardHeader'
import CommentSection from 'containers/Project/GreenlightCommentSection/index'
import FileSection from 'containers/Project/GreenlightFile/index'
import Report from 'containers/Project/GreenlightReport/index'
import Section from 'components/custom/Section/Section'
import Actions from './Actions'
import FtsVersion from './FtsVersion'


import {
  default as Collapse,
  withCollapse
} from 'components/fulcrum/collapse/Collapse'

import {
  mount,
  unmount,
  postFastTrack
} from './actions'

import {
  currentRevisionSelector,
  revisionSelector,
  approvedSelector,
  ftsVersionSelector,
} from 'containers/Project/GreenlightReport/selectors'
import {
  selectedFastTrackProject
} from './selectors'
import { projectIdSelector } from 'containers/Project/View/selectors'

import {
  rejectApproval,
  acceptApproval,
  changeRevision
} from 'containers/Project/GreenlightReport/actions'
import FastTrackDialog from 'containers/Project/GreenlightSection/FastTrackDialog/index'

import {
  segmentSelector
} from 'containers/Project/View/selectors'
import {
  projectsSourceSelector
} from 'containers/Project/Hierarchies/selectors'

const mapStateToProps = state => {
  return {
    current: currentRevisionSelector(state),
    relatedProjects: projectsSourceSelector(state),
    revisions: revisionSelector(state),
    approved: approvedSelector(state),
    ftsVersion: ftsVersionSelector(state),
    selectedFastTrackProject: selectedFastTrackProject(state),
    projectId: projectIdSelector(state),
    segment: segmentSelector(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    mount: () => dispatch(mount()),
    unmount: () => dispatch(unmount()),
    onAccept: () => dispatch(acceptApproval()),
    onReject: (value) => dispatch(rejectApproval()),
    onRevisionChange: (value) => dispatch(changeRevision(value)),
    postFastTrack: (projectId, sourceProjectId) => dispatch(postFastTrack(projectId, sourceProjectId))
  }
}

class GreenLightCard extends Component {

  onImport() {
    const {
      toggleDialogActive,
      postFastTrack,
      projectId,
      selectedFastTrackProject
    } = this.props
    postFastTrack(parseInt(projectId), selectedFastTrackProject)
    toggleDialogActive()
  }

  render() {
    const {
      onAccept,
      onReject,
      onRevisionChange,
      revisions,
      current,
      approved,
      segment,
      collapse,
      toggleCollapse,
      ftsVersion,
      dialogActive,
      toggleDialogActive,
      relatedProjects
    } = this.props
    return (
      <Card>
        <FastTrackDialog
            active={dialogActive}
            toggleActive={toggleDialogActive}
            onImport={() => this.onImport()}
        />
        <CardHeader title={T.translate('containers.project.greenlightSection.index.header')}>
          <Actions
            revisions={revisions}
            current={current}
            segment={segment}
            onRevisionChange={onRevisionChange}
            onAccept={onAccept}
            onReject={onReject}
            approved={approved}
            collapse={collapse}
            toggleCollapse={toggleCollapse}
            toggleDialogActive={toggleDialogActive}
          />
        </CardHeader>
        <Collapse collapse={collapse}>
          <FtsVersion ftsVersion={ftsVersion}></FtsVersion>
          <Divider/>
          <Report/>
          <FileSection/>
          <CommentSection/>
        </Collapse>
      </Card>
    )
  }
}
const GreenLightSection = nest(Section, GreenLightCard)

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withDialogState = compose(
  withState('dialogActive', 'changeDialogActive', false),
  withHandlers({
    toggleDialogActive: ({changeDialogActive}) => () => changeDialogActive(e => !e)
  })
)

const enhance = compose(
  withConnect,
  withCollapse,
  withDialogState,
  lifecycle({
    componentWillMount() { this.props.mount() },
    componentWillUnmount() { this.props.unmount() }
  }),
  branch(
    ({ current, relatedProjects }) => current === null && relatedProjects.length === 0,
    renderNothing
  )
)

export default enhance(GreenLightSection)
